module.exports = __webpack_public_path__ + "img/section2-decor.0c52270b.svg";